import {FeatureTemplate} from '../../model/license/feature-template.model';
import {LicenseTemplate} from '../../model/license/license-template.model';
import axios from '../axios';

export namespace LicenseTemplateController {
  export const queryLicenseTemplates = async () =>
    (await axios.get<LicenseTemplate[]>('/internal/template/license')).data

  export type UpdateLicenseTemplateEntry = {
    licenseTemplateId: string
    monthlyCost: number
    version: number
  }

  export const updateLicenseTemplates = async (licenseTemplates: UpdateLicenseTemplateEntry[]) =>
    (await axios.patch('/internal/template/license', {
      licenseTemplates: licenseTemplates
    }))

  export const queryFeatureTemplates = async () =>
    (await axios.get<FeatureTemplate[]>('/internal/template/feature')).data

  export type UpdateFeatureTemplateEntry = {
    featureTemplateId: string
    activationCost: number
    enabled: boolean
    deliveryDate: string
    version: number
  }

  export const updateFeatureTemplates = async (featureTemplates: UpdateFeatureTemplateEntry[]) =>
    (await axios.patch('/internal/template/feature', {
      featureTemplates: featureTemplates
    }))

  export type LicenseFeatureTemplate = {
    licenseTemplateId: string
    featureTemplateId: string
  }

  export const queryLicenseFeatureTemplates = async () =>
    (await axios.get<LicenseFeatureTemplate[]>('/internal/template/license/feature')).data

  export const createLicenseFeatureTemplate = async (licenseTemplateId: string, featureTemplateId: string) =>
    (await axios.put(`/internal/template/license/${licenseTemplateId}/feature?featureTemplateId=${featureTemplateId}`))

  export const deleteLicenseFeatureTemplate = async (licenseTemplateId: string, featureTemplateId: string) =>
    (await axios.delete(`/internal/template/license/${licenseTemplateId}/feature?featureTemplateId=${featureTemplateId}`))
}